<template>
  <!-- TODO.RIN CHAX-624 - add loading spinner -->
  <div class="limiting-shopping-time-display">
    {{ t.general.remaining }}
    <span class="limiting-shopping-time-display__time">{{ timeLeft }}</span>
    {{ t.general.minutes }}
  </div>
</template>

<script>
  import moment from 'moment';
  import config from '../../../config';
  import CookieHelper from '../../helpers/CookieHelper';
  import DomEventHelper from '../../helpers/DomEventHelper';
  import FormatHelper from '../../helpers/FormatHelper';

  export default {
    data() {
      return {
        t: window.vueLimitingTranslations, // included in header.php
        timeLeft: `00:00`,
        timeLeftInterval: null,
      };
    },
    mounted() {
      /*
       * Date.now() fallback for users that completed a shopping window
       * and add a product to the cart without reloading
       * no cookie exists and we wouldn't have a startTime
       */
      const startTime = parseInt(CookieHelper.getBouncerShoppingStartTime(), 10) || Date.now();
      const endTime = moment(startTime).add(config.bouncer.config.endTimeOffsetInMinutes, `m`).toDate();
      this.calculateTimeLeft(endTime);
      this.timeLeftInterval = window.setInterval(() => {
        this.calculateTimeLeft(endTime);
      }, 1000);
    },
    beforeDestroy() {
      window.clearInterval(this.timeLeftInterval);
    },
    methods: {
      calculateTimeLeft(endTime) {
        const now = Date.now();
        const distance = endTime - now;

        if(distance <= 0) {
          window.clearInterval(this.timeLeftInterval);
          DomEventHelper.fireEvent({ name: `rin-limiting-time-is-up` });
          return;
        }

        this.timeLeft = `${FormatHelper.formatTimeValue(distance, `minute`)}:${FormatHelper.formatTimeValue(distance, `second`)}`;
      },
    },
  };
</script>

<style lang="less" scoped>
  @import '../../assets/styles/rin-variables';

  .limiting-shopping-time-display {
    align-items: center;
    color: @colorBlack;
    display: flex;
    flex-direction: row;
    justify-content: center;
    line-height: 1;

    &__time {
      font-family: @fontSemiBold;
      font-size: 40px;
      letter-spacing: 1px;
      line-height: 1;
      padding: 0 10px;

      @media @fromTablet {
        padding: 0 15px;
      }
    }
  }
</style>
